import React, { useEffect, useReducer, useCallback, useContext } from "react";
import { dataFetchReducer, useStateConnectedToCache } from "../../Utils/requestUtils";
import { CircularProgress } from '@material-ui/core';
import { Link, useHistory } from "react-router-dom";
import axios from "axios";
import BacktestCard from "./BacktestCard/BacktestCard";
import ErrorBoundary from "../../Utils/ErrorBoundary"
import AuthContext from "../../../context/auth-context"
import Pagination from "@material-ui/lab/Pagination";
import { useTranslation } from "react-i18next";

function BacktestInbox(props) {
    let history = useHistory()
    const { t } = useTranslation();

    let user_data = useContext(AuthContext).user_data
    let roles = user_data.roles
    if (!roles.includes("backtest_viewer")){
        history.push("")
    }

    let local_storage_object_preffix = "backtestInbox"

    const [pageParams, setPageParams] = useStateConnectedToCache(local_storage_object_preffix)
    const [pageState, dispatchPageState] = useReducer(
        dataFetchReducer,
        {fetchedData: null, isLoading: true, isError: false}
    )

    const fetchBacktestsList = useCallback(
        (payload) => {
            dispatchPageState({type: "data_fetch_init"})
            const timer = setTimeout(() => {
                axios.get('/dash/backtest/backtests',{params: payload}).then( response => {
                    dispatchPageState({
                        type: "data_fetch_success",
                        payload: response.data
                    })
                }).catch(error => {
                    if ((error.response || {}).status === 403) dispatchPageState({type: "data_fetch_failure_403"})
                    else if ((error.response || {}).status === 404) dispatchPageState({type: "data_fetch_failure_404"})
                    else dispatchPageState({type: "data_fetch_failure"})
                })
            }, 500);
            return () => {
                clearTimeout(timer)
            }
        },[]
    )

    useEffect(() => {
        let payload = {
            "page_number": pageParams.page - 1,
            "page_rows": 15
        }
        const timer_ = setTimeout(() => {
            fetchBacktestsList(payload)
        }, 300);
        return () => {
            clearTimeout(timer_)
        }
    },[fetchBacktestsList, pageParams])

    const handleChangePage = (event, page) => {
        if (pageParams.page === page) {
            return
        }
        setPageParams({...pageParams, page: page})
    }

    const gridTemplateColumns = user_data.business_group_key
        ? "20% 1fr 20% 15% 10%"
        : "1fr 20% 15% 10%"

    const contentContainer = (backtestList) => {
        let nr_of_cards = backtestList['data'].length
        let cards = backtestList['data'].map((backtest) => (
            <ErrorBoundary key={backtest.backtest_key}>
                <BacktestCard
                    backtest={backtest}
                    gridTemplateColumns={gridTemplateColumns}
                    showCompanyColumn={!!user_data.business_group_key}
                />
            </ErrorBoundary>
        ))

        if (nr_of_cards === 0) {
            return (
                <div className='emptyContainer'>
                    <p className={["blueText", "subtitleSize"].join(" ")}>
                        {t("Nenhum backtest configurado")}
                    </p>
                </div>
            )
        }

        return (
            <div className='cardContainer'>
                <div className="listCardHeader" style={{display: "grid", gridTemplateColumns: gridTemplateColumns}}>
                    {user_data.business_group_key && <div
                        className={["listCardItem", "normalText", "normalMediumSize"].join(" ")}
                    >
                        {t("Empresa")}
                    </div>}
                    <div
                        className={["listCardItem", "normalText", "normalMediumSize"].join(" ")}
                    >
                        {t("Nome do backtest")}
                    </div>
                    <div
                        className={["listCardItem", "normalText", "normalMediumSize"].join(" ")}
                    >
                        Status
                    </div>
                    <div
                        className={["listCardItem", "normalText", "normalMediumSize"].join(" ")}
                    >
                        {t("Criado em")}
                    </div>
                    <div
                        className={["listCardItem", "normalText", "normalMediumSize"].join(" ")}
                    >
                    </div>
                </div>
                {cards}
            </div>
        )
    }

    if (pageState.fetchedData) {
        return (
            <div style={{ width: "auto", paddingBottom: "30px" }}>
                <div style={{display:"flex"}}>
                    <div>
                        <p className={["blueText", "titleSize"].join(" ")}>{t("BACKTEST DE REGRAS")}</p>
                    </div>
                    <div style={{display:"flex", margin: "auto 50px auto auto", flexDirection:"row"}}>
                        <Link
                            style={{ padding: "5px 30px", textDecoration:"none" }}
                            className={["button", "link", "standard", "normalText", "normalMediumSize"].join(" ")}
                            to={"/backtest/new_backtest"}
                        >
                            {t("CRIAR BACKTEST")}
                        </Link>
                    </div>
                </div>
                <div className="cardList">{contentContainer(pageState.fetchedData)}</div>
                <Pagination
                    className="pagination"
                    page={pageParams.page}
                    count={parseInt(pageState.fetchedData["number_of_pages"])}
                    onChange={(e, page) => handleChangePage(e, page)}
                />
            </div>
        );
    }
    else if (pageState.isError){
        return (
            <div style={{ width: "auto" }}>
                <div style={{display:"flex"}}>
                    <div >
                        <p className={["blueText", "titleSize"].join(" ")}>{t("BACKTEST DE REGRAS")}</p>
                    </div>
                </div>
                <div style={{height: "55vh", display:"flex"}}>
                    <p className={["blueText", "titleSize"].join(" ")} style={{margin:"auto", textAlign:"center"}}>
                        {pageState.errorMessage}
                    </p>
                </div>
            </div>
        )
    }
    else if (pageState.isLoading) {
        return(
            <div style={{ width: "auto" }}>
                <p className={["blueText", "titleSize"].join(" ")}>{t("BACKTEST DE REGRAS")}</p>
                <div className='circularProgressCenter'>
                    <CircularProgress />
                </div>
            </div>
        )
    }
    else return null

}

export default BacktestInbox
